import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ConnectionService } from 'src/app/connection.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({              
  selector: 'app-blocksid',
  templateUrl: './blocksid.component.html',
  styleUrls: ['./blocksid.component.css']
})
export class BlocksidComponent implements OnInit {
  blockDetailsList: any;
  blockNumber: any;
  blockId: any;
  transactionInfo: any;
  transTime: any;
  timeString: string = '';

  constructor(private conn: ConnectionService,
    private activatedRoute: ActivatedRoute,
    private alert: ToastrService, private spinner: NgxSpinnerService) {
    this.blockNumber = this.activatedRoute.snapshot.params['id'];
  }

  ngOnInit() {
    this.blockDetails();
    setTimeout(()=>
    {
      this.calculateTimeRemaining();
    },2000)
  }

  blockDetails() {
    // this.spinner.show()
    this.conn.postUrl('users/getblockDetails', { block: Number(this.blockNumber) }).subscribe((res: any) => {
      // this.spinner.hide()
      this.blockId = res.data.blockID ? res.data.blockID : '' || res.data.blockData ? res.data.blockData.blockID : ''
      this.blockDetailsList = res.data.blockData ? res.data.blockData.block_header.raw_data : res.data.block_header.raw_data
      this.transTime = this.blockDetailsList?.timestamp || res.data.block_header.raw_data.timestamp
      this.transactionInfo = res.data?.transblock ? res.data?.transblock[0] : res.data?.transblock

    })
  }

  calculateTimeRemaining() {

    const currentTime = new Date().getTime();

    const timeDifference = currentTime - this.transTime;
    if (timeDifference > 0) {
      const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
      this.timeString = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      setTimeout(() => {
        this.calculateTimeRemaining();
      }, 1000);
    } else {
      // this.timeString = 'Timer expired!';
    }
  }

  copyText(val: string) {
    let selBox = document.createElement('input');
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.alert.success('Copied to the clipboard');
  }
}
